<template>
    <div class="dating-insincere">
        <StackRouterHeaderBar />
        <main class="main">
            <FeedbackTop class="m-b-40" :title="'왜 진정성이 없다고<br />느끼셨나요?'" />
            <FeedbackOptionItems class="m-b-12" v-model="items" :multiSelect="true" />

            <transition name="slide-down">
                <div v-if="showDetailReason" class="detail-reason">
                    <p class="desc">기타 사유를 직접 입력해주세요</p>
                    <TextareaWithX :placeholder="'내용을 입력해주세요'" v-model="detailReason" />
                </div>
            </transition>
        </main>

        <footer class="footer">
            <button class="btn btn-primary" v-html="$translate('NEXT')" :disabled="disabled" @click="onClickNext" />
        </footer>
    </div>
</template>

<script>
import FeedbackTop from './components/FeedbackTopComponent'
import FeedbackOptionItems from './components/FeedbackOptionItems'

export default {
    name: 'DatingInsincerePage',
    components: { FeedbackTop, FeedbackOptionItems },
    props: {
        user: Object,
    },
    data: () => ({
        detailReason: '',
        items: [],
    }),
    computed: {
        disabled() {
            return this.items.every(item => !item.selected)
        },
        showDetailReason() {
            return this.items[5].selected
        },
    },
    methods: {
        async init() {
            try {
                const options = await this.$store.dispatch('filterFeedbackOptionByCategory', 'sincerity_reason')
                this.items = options.map(option => {
                    this.$set(option, 'selected', false)
                    return option
                })
            } catch (e) {}
        },
        onClickNext() {
            const payload = this.preparedPayload()
            this.$store.commit('setSelectedFeedbacks', { category: 'insincerity', feedbacks: payload })

            this.$stackRouter.push({
                name: 'DatingMannerPage',
                props: { user: this.user },
            })
        },
        preparedPayload() {
            return this.items
                .filter(item => item.selected)
                .map(item => {
                    if (item.title === '기타') {
                        return { id: item.id, detail: this.detailReason }
                    } else {
                        return { id: item.id }
                    }
                })
        },
    },
    mounted() {
        this.init()
    },
}
</script>

<style lang="scss" scoped>
.dating-insincere {
    .main {
        height: calc(100% - 80px - 56px);
        overflow-y: auto;
        padding: 0 16px;
    }

    .detail-reason {
        margin-bottom: 16px;

        .desc {
            margin-bottom: 8px;
            font-size: 12px;
            color: $grey-06;

            @include f-medium;
        }

        .textarea-with-x {
            height: 160px;
        }

        ::v-deep textarea {
            font-size: 14px;
        }
    }

    .footer {
        position: absolute;
        bottom: 0;
        padding: 16px 20px;
        width: 100vw;
        border-top: solid 1px $grey-02;
        background-color: white;

        .btn {
            width: 100%;
            height: 48px;
        }
    }
}
</style>
